var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3832 0 0 5.3832 0 12V12.8568V16.8V16.9716C0 18.2004 1.0764 19.2 2.4 19.2H3.6C4.2636 19.2 4.8 18.6624 4.8 18V11.8284C4.8 11.166 4.2636 10.6284 3.6 10.6284H2.5104C3.1776 5.9844 7.1736 2.4 12 2.4C16.8264 2.4 20.8224 5.9844 21.4896 10.6284H20.4C19.7364 10.6284 19.2 11.166 19.2 11.8284V16.8V18V19.2C19.2 20.5236 18.1236 21.6 16.8 21.6H14.4V20.4H9.6V24H12H14.4H16.8C19.4472 24 21.6 21.8472 21.6 19.2C22.9236 19.2 24 18.2004 24 16.9716V16.8V12.8568V12C24 5.3832 18.6168 0 12 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.0c526995.svg";
export { ForwardRef as ReactComponent };